<template>
    <div class="find-a-doctor-filters-section">
        <h4 class="find-a-doctor-filters-section__header" v-text="header" />
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        header: {
            type: String,
        },
    },
};
</script>
